// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
export default {
  path: "/account/sign-in/",
  component: require("./GlobalAuth").default
}
